export default __webpack_public_path__ + "static/media/img03.cb015eba.png";